import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
} from "@mui/material";

const SaleDetails = () => {

    const { id } = useParams(); // Use useParams to get the id from the URL 
    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate, branchId } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
    });

    const [selectedItems, setSelectedItems] = useState([]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    //handle search [ITEM SEARCH]    
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSelectedItems(response.response_data.SaleDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "13px",
                width: "100%",
                padding: "5px",
                marginTop: '-30px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "13px",
                    flexWrap: "nowrap", // ❌ prevent wrapping
                    gap: "20px", // spacing between form and buttons
                }}
            >
                {/* Title */}
                <h6
                    className="uppercase tracking-wide font-serif text-black mt-2"
                    style={{ flex: "0 0 auto" }}
                >
                    Sale Details
                </h6>

                {/* Form Grid */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "300px 140px 150px 120px 120px 120px", // ✅ fixed widths
                        gap: "13px",
                        alignItems: "end",
                        flex: "1", // occupy remaining space
                    }}
                >
                    {/* Party Name */}
                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                marginBottom: "2px",
                                display: "block",
                            }}
                        >
                            Party Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.CustomerName}
                            type="text"
                            placeholder="CustomerName"
                            name='CustomerName'
                            readOnly
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                marginBottom: "2px",
                                display: "block",
                            }}
                        >
                            Ph.No
                        </label>
                        <input
                            type="text"
                            name="ContactNumber"
                            value={formData.ContactNumber}
                            //onChange={handleChange}
                            readOnly
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    {/* Invoice Type */}
                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                marginBottom: "2px",
                                display: "block",
                            }}
                        >
                            Invoice Type
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.InvoiceTypeName}
                            type="text"
                            placeholder="InvoiceTypeName"
                            name='InvoiceTypeName'
                            readOnly
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    {formData.InvoiceTypeId === 4 && (
                        <div>
                            <label
                                style={{
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    marginBottom: "2px",
                                    display: "block",
                                }}
                            >
                                State
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.StateName}
                                type="text"
                                placeholder="StateName"
                                name='StateName'
                                readOnly
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "13px",
                                    height: "28px",
                                    width: "100%",
                                    padding: "0 6px",
                                }}
                            />
                        </div>
                    )}

                    {/* Sale Date */}
                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                marginBottom: "2px",
                                display: "block",
                            }}
                        >
                            Sale Date
                        </label>
                        <input
                            type="date"
                            name="BillDate"
                            value={formatDateForInput(formData.BillDate)}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>

                    {/* Bill Number */}
                    <div>
                        <label
                            style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                marginBottom: "2px",
                                display: "block",
                            }}
                        >
                            Bill Number
                        </label>
                        <input
                            type="text"
                            name="BillNumber"
                            value={`${formData.BillNumber || ""}/${formData.FinYear || ""}`}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>
                </div>

                {/* Buttons */}
                <div
                    className="flex items-center gap-3 mt-2 md:mt-0"
                    style={{ flexShrink: 0, whiteSpace: "nowrap" }} // ✅ keep in one line
                >

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/SaleIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6",
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                        }}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* Top Section - Supplier & Bill */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(150px, 1.5fr) repeat(9, minmax(80px, 1fr))",
                    gap: "10px",
                    marginBottom: "13px",
                    alignItems: "end",
                }}
            >
                {/* Sale Man */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Sale Man</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={formData.SalesManName}
                        type="text"
                        placeholder="SalesManName"
                        name='SalesManName'
                        readOnly
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />

                </div>

                {/* Freight */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Freight
                        <span style={{ color: "darkmagenta", marginLeft: "10px" }}>
                            ({formData.FreightGSTRate}%)
                        </span>
                        <span style={{ color: "red", marginLeft: "10px" }}>
                            {formData.FreightGSTAmount}
                        </span>
                    </label>
                    <input
                        type="number"
                        name="FreightAmount"
                        value={formData.FreightAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Packing */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Packing
                        <span style={{ color: "darkmagenta", marginLeft: "10px" }}>
                            ({formData.PackingGSTRate}%)
                        </span>
                        <span style={{ color: "red", marginLeft: "10px" }}>
                            {formData.PackingGSTAmount}
                        </span>
                    </label>
                    <input
                        type="number"
                        name="PackingAmount"
                        value={formData.PackingAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* TCS */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TCS</label>
                    <input
                        type="number"
                        name="TCSAmount"
                        value={formData.TCSAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Round Off */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        readOnly
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Total */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total</label>
                    <input
                        type="number"
                        name="GrandTotal"
                        value={formData.GrandTotal}
                        readOnly
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Cash */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Cash</label>
                    <input
                        type="number"
                        name="CashAmount"
                        placeholder="CashAmount"
                        value={formData.CashAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CardAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Card */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Card</label>
                    <input
                        type="number"
                        name="CardAmount"
                        placeholder="CardAmount"
                        value={formData.CardAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.UPIAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* UPI */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>UPI</label>
                    <input
                        type="number"
                        name="UPIAmount"
                        placeholder="UPIAmount"
                        value={formData.UPIAmount}
                        min="0"
                        max={Math.max(
                            0,
                            parseFloat(formData.GrandTotal || 0) -
                            (parseFloat(formData.CashAmount || 0) +
                                parseFloat(formData.CardAmount || 0))
                        )}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                        }}
                    />
                </div>

                {/* Balance */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Balance</label>
                    <input
                        type="text"
                        name="BalanceAmount"
                        placeholder="BalanceAmount"
                        value={formData.BalanceAmount}
                        readOnly
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "15px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: formData.BalanceAmount > 0 ? "red" : "inherit",
                        }}
                    />
                </div>
            </div>


            {/* Amount Summary */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: "8px",
                    marginBottom: "13px",
                    fontSize: "13px"
                }}
            >
                <div style={{ fontWeight: "bold" }}>
                    Amount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TotalAmount}
                    </span>
                </div>
                <div style={{ fontWeight: "bold" }}>
                    Discount:{" "}
                    <span style={{ color: "#210d0dff", fontWeight: "bold" }}>
                        {formData.DiscountAmount}
                    </span>
                </div>
                <div style={{ fontWeight: "bold" }}>
                    Taxable:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TaxableAmount}
                    </span>
                </div>
                <div style={{ fontWeight: "bold" }}>
                    CGST: <span style={{ color: "#B71C1C", fontWeight: "bold", }}>{formData.CGSTAmount}</span>
                </div>
                <div style={{ fontWeight: "bold" }}>
                    SGST: <span style={{ color: "#B71C1C", fontWeight: "bold", }}>{formData.SGSTAmount}</span>
                </div>
                <div style={{ fontWeight: "bold" }}>
                    IGST: <span style={{ color: "#B71C1C", fontWeight: "bold", }}>{formData.IGSTAmount}</span>
                </div>
            </div>

            {/* Data Table */}
            <div
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "13px",
                    border: "1px solid #999",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        fontFamily: "monospace",
                    }}
                >
                    <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                        <tr>
                            {[
                                "SL.No",
                                "Item",
                                "Qty",
                                "Rate",
                                "Amount",
                                "Disc%",
                                "Disc₹",
                                "Taxable",
                                "GST₹",
                                "Total",
                            ].map((header, idx) => (
                                <th
                                    key={idx}
                                    style={{
                                        padding: "3px",
                                        //textAlign: idx > 1 & 9 ? "right" : "left",
                                        textAlign: idx > 1 ? "center" : "left",
                                        borderBottom: "1px solid #ccc",
                                        textTransform: 'uppercase',
                                        fontSize: '10px'
                                    }}                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                {/* SL.No + Delete */}
                                <td style={{ padding: "4px 6px", textAlign: "center" }}>
                                    {index + 1}
                                </td>

                                {/* Item Name */}
                                <td
                                    style={{
                                        fontSize: "13px",
                                        //fontWeight: "bold",
                                        padding: "4px",
                                        minWidth: "200px",
                                    }}
                                >
                                    {item.ItemName}
                                </td>

                                {/* Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.Quantity}
                                        name="Quantity"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Rate */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.Rate || 0}
                                        name="Rate"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.Amount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            fontWeight: "bold",
                                            padding: "2px",
                                            borderRadius: "3px",
                                        }}
                                    />
                                </td>

                                {/* Discount % */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.DiscountPercentage || 0}
                                        name="DiscountPercentage"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",

                                        }}
                                    />
                                </td>

                                {/* Discount Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.DiscountAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Taxable */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TaxableAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* GST */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={
                                            parseFloat(item.CGSTAmount) +
                                            parseFloat(item.SGSTAmount) +
                                            parseFloat(item.IGSTAmount)
                                        }
                                        readOnly
                                        style={{
                                            width: "70%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                        }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "4px",
                                            color: "darkmagenta",
                                            fontSize: "11px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                    </span>
                                </td>

                                {/* Total */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TotalAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#DDE9EC",
                                            border: "1px solid #888",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                            color: 'brown'
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Top Section - Remarks & Bank */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: formData.UPIAmount > 0 || formData.CardAmount > 0
                        ? "3fr 1fr" // show both side by side
                        : "1fr",    // only Remarks
                    gap: "8px",
                    //marginBottom: "13px",
                    fontSize: "13px",
                    alignItems: "end",
                }}
            >
                {/* Remarks */}
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <textarea
                        name="Remarks"
                        value={formData.Remarks}
                        rows={1}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "13px",
                            width: "100%",
                            padding: "4px",
                            resize: "vertical",
                        }}
                    />
                </div>

                {/* Bank - conditional */}
                {(formData.UPIAmount > 0 || formData.CardAmount > 0) && (
                    <div>
                        <label style={{ fontSize: "11px", fontWeight: "600" }}>Bank</label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.BankName}
                            type="text"
                            placeholder="BankName"
                            name='BankName'
                            readOnly
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "13px",
                                height: "28px",
                                width: "100%",
                                padding: "0 6px",
                            }}
                        />
                    </div>
                )}
            </div>


        </div>
    );
}
export default SaleDetails;
